import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type RoomsToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function RoomsToolbar({ canManage, onCreate }: RoomsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div className="flex items-center gap-2">
          <div className="">
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ຫ້ອງຮຽນ
            </h2>
            <p className="text-muted-foreground">ຈັດການຫ້ອງຮຽນໃນລະບົບ.</p>
          </div>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງຫ້ອງຮຽນ
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
